import axios from 'axios';
import { ROUTER_BASENAME } from '../config/routerBasename';
import { clearClientSession } from '../utils/clearClientSession';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        clearClientSession();
        const serverPath = error.response?.data?.redirectTo;
        if (typeof serverPath === 'string' && serverPath.startsWith('/')) {
          window.location.assign(serverPath);
        } else {
          const href = ROUTER_BASENAME ? `${ROUTER_BASENAME}/login` : '/login';
          window.location.assign(href);
        }
      }

      if (status === 403) {
        console.error('Access Forbidden: You do not have permission to perform this action.');
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
